"use client";
import React from 'react';
import { FeatureList } from './FeatureList';
import { TestimonialCard } from './TestimonialCard';

const testimonials = [
  {
    text: "Com o Cartão Nação Saúde, minha rotina mudou para melhor. Hoje, economizo em exames, consultas médicas e até nas compras de farmácia. Além disso, não preciso mais enfrentar as longas filas de atendimento no UPA. Quando preciso, sou atendido rapidamente por telemedicina, com profissionais do Hospital Albert Einstein, sem sair de casa. É praticidade, qualidade e economia em um único benefício.",
    author: "Gabirel Guerra",
    location: "Cliente B2C"
  },
  {
    text: "Agendamentos de exames com muita facilidade, preço acessível ao nosso bolso, minha mãe é aposentada sem condições de pagar um convênio , o cartão nação saúde foi maravilhoso, hoje ela consegue fazer exames médicos com preços bem acessíveis. Bem mais vantajoso que pagar um plano de saúde para idosa de 75 anos",
    author: "Rosangela Bueno",
    location: "Empresa Digycon"
  },
  {
    text: "A CNS é mais que um parceiro necessário! Necessário porque oferece acesso a serviços essenciais de saúde e bem estar, mas é mais que isso porque oferece autonomia e menos burocracia nessa operação. Além da qualidade, agilidade e facilidade em todo processo, da contratação ao uso dos parceiros!",
    author: "Gustavo Loreiro Gomes",
    location: "Empresa Hug"
  }
];

export const WhyChooseSection = () => {
  return (
    <section
      className="position-relative overflow-hidden"
      style={{
        minHeight: '431px',
        backgroundColor: '#2B5CE6'
      }}
    >
      {/* Desktop Layout */}
      <div className="d-none d-lg-block">
        <div className="container-fluid h-100">
          <div className="row h-100">
            {/* Left side - Title and Features */}
            <div className="col-lg-6 d-flex flex-column justify-content-center">
              <div style={{ marginLeft: '154px', marginTop: '32px' }}>
                <header className="mb-4">
                  <h1
                    className="text-white fw-bold mb-4"
                    style={{ fontSize: '36px', maxWidth: '373px' }}
                  >
                    Por que escolher a Nação Saúde?
                  </h1>
                </header>
                <FeatureList />
              </div>
            </div>

            {/* Right side - Carousel */}
            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <div style={{ marginTop: '110px', maxWidth: '474px' }}>
                <div
                  id="testimonialCarousel"
                  className="carousel slide"
                  data-bs-ride="carousel"
                  data-bs-interval="10000"
                >
                  <div className="carousel-indicators">
                    {[0, 1, 2].map((i) => (
                      <button
                        key={i}
                        type="button"
                        data-bs-target="#testimonialCarousel"
                        data-bs-slide-to={i}
                        className={i === 0 ? 'active' : ''}
                        aria-current={i === 0 ? 'true' : undefined}
                        aria-label={`Slide ${i + 1}`}
                        style={{
                          width: '9px',
                          height: '9px',
                          borderRadius: '50%',
                          backgroundColor: i === 0 ? '#289E46' : '#8499C4',
                          border: 'none',
                          margin: '0 6px'
                        }}
                      ></button>
                    ))}
                  </div>

                  <div className="carousel-inner">
                    {testimonials.map((testimonial, index) => (
                      <div
                        key={index}
                        className={`carousel-item ${index === 0 ? 'active' : ''}`}
                      >
                        <div className="px-3">
                          <TestimonialCard
                            text={testimonial.text}
                            author={testimonial.author}
                            location={testimonial.location}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="d-lg-none">
        <div className="container-fluid py-5 px-4">
          {/* Title */}
          <header className="text-center mb-4">
            <h1
              className="text-white fw-bold"
              style={{ fontSize: '28px' }}
            >
              Por que escolher a Nação Saúde?
            </h1>
          </header>

          {/* Features List */}
          <div className="mb-5">
            <FeatureList />
          </div>

          {/* Carousel */}
          <div>
            <div
              id="testimonialCarouselMobile"
              className="carousel slide"
              data-bs-ride="carousel"
              data-bs-interval="10000"
            >
              <div className="carousel-indicators">
                {[0, 1, 2].map((i) => (
                  <button
                    key={i}
                    type="button"
                    data-bs-target="#testimonialCarouselMobile"
                    data-bs-slide-to={i}
                    className={i === 0 ? 'active' : ''}
                    aria-current={i === 0 ? 'true' : undefined}
                    aria-label={`Slide ${i + 1}`}
                    style={{
                      width: '9px',
                      height: '9px',
                      borderRadius: '50%',
                      backgroundColor: i === 0 ? '#289E46' : '#8499C4',
                      border: 'none',
                      margin: '0 6px'
                    }}
                  ></button>
                ))}
              </div>

              <div className="carousel-inner">
                {testimonials.map((testimonial, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${index === 0 ? 'active' : ''}`}
                  >
                    <div className="px-3">
                      <TestimonialCard
                        text={testimonial.text}
                        author={testimonial.author}
                        location={testimonial.location}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;